const icon = require('vue-svgicon');
icon.register({
    'facebook': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 9.045C1 13.022 3.889 16.329 7.667 17v-5.778h-2V9h2V7.222c0-2 1.288-3.11 3.111-3.11.577 0 1.2.088 1.777.177v2.044h-1.022c-.978 0-1.2.489-1.2 1.112V9h2.134l-.356 2.222h-1.778V17C14.111 16.33 17 13.023 17 9.045 17 4.62 13.4 1 9 1S1 4.62 1 9.045z" _fill="#F9F9FC"/>`,
    },
});
